import {
  MESSAGE_LOAD,
  MESSAGE_LOAD_SUCCESS,
  MESSAGE_ERROR,
  MESSAGE_CLEAN
} from "./actionTypes"

const initialState = {
  error: "",
  types: [],
  loading: false,
  current: null,
}

const messageDashBoard = (state = initialState, action) => {
  switch (action.type) {
    case MESSAGE_LOAD:
      state = {
        ...state,
        types: [],
        loading: true,
        error: "",
      }
      break
    case MESSAGE_LOAD_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: "",
        types: action.payload,
      }
      break
    case MESSAGE_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
        current: null
      }
      break

    case MESSAGE_CLEAN:
      state = {
        ...state,
        loading: false,
        error: "",
      }
      break

  }
  return state
}

export default messageDashBoard
